module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app-root"
    }
  }, [_c('router-view'), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "id": "appErrors",
      "value": _vm.snackbar,
      "timeout": 0,
      "multi-line": _vm.$store.state.applicationMessages.multiline,
      "color": _vm.$store.state.applicationMessages.class,
      "auto-height": true
    }
  }, [_vm._l((_vm.$store.state.applicationMessages.messages), function(msg) {
    return _c('v-flex', {
      attrs: {
        "x12": ""
      }
    }, [_vm._v(_vm._s(msg))])
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.dimiss
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-55f0f5a0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55f0f5a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/src/app.vue.html
// module id = 590
// module chunks = 0